import ContainedHead from 'components/ContainedHead';
import Loader from 'components/Loader';
import PcModel from 'containers/PcModel';
import getProductPrices from 'helpers/getProductPrices';
import getProductStock from 'helpers/getProductStock';
import { getDocumentByUid } from 'helpers/Prismic';
import { API } from 'lib/arkade-graphql';
import { productView } from 'lib/events/fb-pixel/product-view';
import Error from 'next/error';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import globalProps from 'utils/globalProps';

const PcModels = ({ pcModel, prices, ogImage, stocks, pcConfigDoc, modelTheme }) => {
  const { isFallback, asPath } = useRouter();

  if (isFallback) {
    return <Loader />;
  }

  if (!pcModel) {
    return <Error code={404} />;
  }

  const {
    seo_title: seoTitle,
    seo_description: seoDescription,
    model_title: title,
    model_description: description,
  } = pcModel || {};

  useEffect(() => {
    const productViewEvent = () => {
      productView(
        {
          id: pcModel?.slug,
          title,
          price: pcModel?.price,
        },
        'pc-model',
      );
    };
    productViewEvent();
  }, []);

  const resizeWindow = () => {
    if (window.outerWidth < 450) {
      const footerDiv = document.getElementById('footer');
      footerDiv.style.display = 'none';
    }
  };

  useEffect(() => {
    window.addEventListener('resize', resizeWindow);
    return () => window.removeEventListener('resize', resizeWindow);
  }, []);

  return (
    <>
      <ContainedHead
        title={seoTitle || title}
        description={seoDescription || description}
        path={asPath}
        ogImage={ogImage}
      />
      <PcModel
        pcModel={pcModel}
        prices={prices}
        stocks={stocks}
        pcConfigDoc={pcConfigDoc}
        modelTheme={modelTheme}
      />
    </>
  );
};

export async function getStaticProps({ params, preview = false, previewData }) {
  const { uid: slug } = params;

  const { ref } = previewData || {};
  const {
    props: { global },
  } = await globalProps();

  const pcModel = await API.getPcModelBySlug(slug);

  if (!pcModel) {
    return { notFound: true };
  }

  const pcConfigDoc = await getDocumentByUid('pc_config', 'pc-config', ref);

  const stocks = getProductStock(pcModel).map((stock) => stock.toJS());

  const prices = getProductPrices(pcModel).map((price) => price.toJS());
  const pcModelUID = params.uid;
  const pcModelResult = await getDocumentByUid('pc_model', pcModelUID, ref);
  const ogImage = pcModelResult?.data.og_image?.url || null;
  const modelTheme = pcModelResult?.data;

  let toggle_components_desktop = modelTheme?.toggle_components_desktop;
  let toggle_components_mobile = modelTheme?.toggle_components_mobile;
  let show_graph_block = modelTheme?.show_graph_block;

  if (show_graph_block == undefined) {
    show_graph_block = true;
  }

  if (toggle_components_desktop == undefined) {
    toggle_components_desktop = true;
  }

  if (toggle_components_mobile == undefined) {
    toggle_components_mobile = true;
  }

  let toggle_design = modelTheme?.toggle_design;
  if (toggle_design == undefined) {
    toggle_design = false;
  }

  let ultralabs_video = '';
  if (pcConfigDoc?.data.body?.length > 0) {
    ultralabs_video = pcConfigDoc?.data.body[0]?.primary;
  }

  const props = {
    global,
    pcModel,
    ogImage,
    prices,
    stocks,
    pcConfigDoc,
    preview,
    modelTheme: {
      position: modelTheme?.banner_content_position || 'Left',
      color: modelTheme?.banner_text_color_theme || 'Light',
      breadcrumbs: modelTheme?.breadcrumbs || null,
      toggle_components_desktop: toggle_components_desktop,
      toggle_components_mobile: toggle_components_mobile,
      toggle_design: toggle_design,
      ultralabs_video: ultralabs_video,
      show_graph_block: show_graph_block,
    },
  };

  return {
    props,
  };
}

export async function getStaticPaths() {
  const pcModelSlugs = await API.getPcModelStaticPaths();
  const paths = pcModelSlugs.map((slug) => ({ params: { uid: slug } }));
  return {
    paths,
    fallback: true,
  };
}

export default PcModels;
